import { arrayOf, number, node } from "prop-types"
import { css } from "@emotion/core"

const StepProgress = ({ steps, currentStep }) => {
  const styles = {
    stepLabel: css`
      font-size: 0.875rem;
      padding-top: 24px;
      position: relative;
      &:before {
        border-radius: 16px;
        content: " ";
        height: 16px;
        left: 50%;
        margin-left: -8px;
        position: absolute;
        top: 0;
        width: 16px;
        z-index: 2;
      }
    `,
    stepProgressBar: css`
      &:after {
        content: " ";
        height: 3px;
        position: absolute;
        right: 20px;
        top: 7px;
        width: 110px;
        z-index: 1;
      }
    `
  }
  return (
    <div className="d-f jc-sb ai-c mb-3 mx-a" css={{ width: 260 }}>
      {steps.map((step, index) => {
        return (
          <div
            key={`progress${index}`}
            css={css`
              ${styles.stepLabel};
              ${index > 0 ? styles.stepProgressBar : {}};
              &:before {
                background-color: ${currentStep >= index
                  ? "var(--t-fill-color-interaction-default)"
                  : "var(--t-fill-color-neutral-050)"};
              }
              &:after {
                background-color: ${currentStep >= index
                  ? "var(--t-fill-color-interaction-default)"
                  : "var(--t-fill-color-neutral-050)"};
              }
            `}
          >
            {step.label}
          </div>
        )
      })}
    </div>
  )
}

StepProgress.propTypes = {
  steps: arrayOf(node),
  currentStep: number
}

export default StepProgress
